<template>
  <div class="dtpckr_pickers datepickers">
    <div class="dtpckr_select">
      <div class="dtpckr_from dtpckr_box">
        <div class="dtpckr_title">
          <div :class="`dtpckr_title_pre_${$i18n.locale}`">
            {{ $t(strDateFromPath) }}
          </div>
          <div class="weight_700 px-2">
            {{ l_dateFrom ? formatISODate(l_dateFrom) : null }}
          </div>
        </div>
        <v-date-picker
          color="var(--clr-primary)"
          :modelValue="l_dateFrom ? parseISO(l_dateFrom) : null"
          :show-adjacent-months="true"
          :hide-header="true"
          :allowedDates="allowedDates"
          @update:modelValue="handleInputDateFrom"
        />
      </div>
      <div
        v-if="show_time_from"
        class="dtpckr_time_from mh-0 f-column flex-1"
      >
        <div class="dtpckr_title">
          <div :class="`dtpckr_title_pre_${$i18n.locale}`">
            {{ $t(strTimeFromPath) }}
          </div>
          <div class="weight_700 px-2">
            {{ l_timeFrom }}
          </div>
        </div>
        <GwTimePicker
          :value="l_timeFrom"
          @change="handleInputTimeFrom"
        />
      </div>
    </div>
    <div
      v-if="show_date_to"
      class="dtpckr_to dtpckr_box"
    >
      <div class="dtpckr_title">
        <div :class="`dtpckr_title_pre_${$i18n.locale}`">
          {{ $t('table_filter.date_to') }}
        </div>
        <div class="weight_700 px-2">
          {{ l_dateTo ? formatISODate(l_dateTo) : null }}
        </div>
      </div>
      <v-date-picker
        color="var(--clr-primary)"
        :modelValue="l_dateTo ? parseISO(l_dateTo) : null"
        :show-adjacent-months="true"
        :hide-header="true"
        :allowedDates="allowedDates"
        @update:modelValue="handleInputDateTo"
      />
    </div>
    <div v-if="show_time_to">
      <div class="dtpckr_title">
        <div class="weight_700 px-2">
          {{ l_timeTo }}
        </div>
      </div>
      <GwTimePicker
        :value="l_timeTo"
        @change="handleInputTimeTo"
      />
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import GwTimePicker from '@/components/lib/GwTimePicker'
import {
  format, //
  parseISO,
} from 'date-fns'

// TODO
// show_time_from >> hasTimeFrom ... etc
export default {
  name: 'DatepickerPickers',
  components: {
    GwTimePicker,
  },
  mixins: [format_mix, float_mix],
  props: {
    localOnly: Boolean,

    strDateFromPath: { default: 'table_filter.date_from' },
    strTimeFromPath: { default: 'table_filter.time_from' },
    date_to: String,
    date_from: String,
    time_from: String,
    time_to: String,

    show_time_from: Boolean,
    show_time_to: Boolean,
    show_date_to: { type: Boolean, default: true },

    pastDaysAllowed: { type: Number, default: -1 },
  },
  emits: ['input:date_from', 'input:date_from_time', 'input:date_to', 'input:date_to_time'],
  data() {
    return {
      l_dateFrom: '',
      l_dateTo: '',
      l_timeFrom: '',
      l_timeTo: '',
    }
  },
  created() {
    // console.log({
    //   date_from: this.date_from,
    //   date_to: this.date_to,
    //   time_from: this.time_from,
    //   time_to: this.time_to,
    // })
    this.l_dateFrom = this.date_from
    this.l_dateTo = this.date_to
    this.l_timeFrom = this.time_from
    this.l_timeTo = this.time_to

    // this.maxDateISO = format(new Date(), 'yyyy-MM-dd') // today
  },
  methods: {
    parseISO(date) {
      return parseISO(date)
    },
    formatToISO(date) {
      return format(date, 'yyyy-MM-dd')
    },
    allowedDates(date) {
      if (this.pastDaysAllowed === -1) return true

      const today = new Date()
      const pastDate = new Date()
      pastDate.setDate(today.getDate() - this.pastDaysAllowed)
      const parsedDate = new Date(date)

      return parsedDate <= today && parsedDate >= pastDate
    },
    handleInputDateFrom(val = this.l_dateFrom) {
      this.l_dateFrom = this.formatToISO(val)
      if (this.localOnly) return
      this.$emit('input:date_from', this.formatToISO(val))
    },
    handleInputDateTo(val = this.l_dateTo) {
      this.l_dateTo = this.formatToISO(val)
      if (this.localOnly) return
      this.$emit('input:date_to', this.formatToISO(val))
    },
    handleInputTimeFrom(val = this.l_timeFrom) {
      this.l_timeFrom = val
      if (this.localOnly) return
      this.$emit('input:date_from_time', this.l_timeFrom)
    },
    handleInputTimeTo(val = this.l_timeTo) {
      this.l_timeTo = val
      if (this.localOnly) return
      this.$emit('input:date_to_time', this.l_timeTo)
    },
    emitAll() {
      this.$emit('input:date_from', this.l_dateFrom)
      this.$emit('input:date_from_time', this.l_timeFrom)
      this.$emit('input:date_to', this.l_dateTo)
      this.$emit('input:date_to_time', this.l_timeTo)
    },
  },
  watch: {
    date_from(val) {
      this.l_dateFrom = val
    },
    date_to(val) {
      this.l_dateTo = val
    },
    time_from(val) {
      this.l_timeFrom = val
    },
    time_to(val) {
      this.l_timeTo = val
    },
  },
}
</script>
<style lang="scss">
.datepickers {
  .v-date-picker-month__day {
    font-weight: 500 !important;
  }
  .v-btn--icon {
    border-radius: 4px !important;
  }
}
.datepickers_hide-controls {
  .v-date-picker-controls {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
.dtpckr {
  &_box {
    border: solid 1px var(--clr-black-1-1);
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
  }
  &_title {
    display: flex;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    font-weight: 500;
    background: var(--clr-black-2);
    border-radius: 4px 4px 0 0;
    &_pre {
      &_ko {
        order: 1;
      }
    }
  }
  &_pickers {
    display: flex;
    grid-gap: 1rem;
    min-height: 0;
    // margin: 1rem 0 0 0;
  }
  &_btns {
    display: flex;
  }
  &_close {
    position: absolute;
    right: 0.25rem;
    top: 0.25rem;
  }
  &_select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 1rem;
  }
}
@media (max-width: 767px) {
  .dtpckr {
    &_pickers {
      flex-wrap: wrap;
    }
  }
}
</style>
